import React from 'react'
import OnceTimerEditor from './OnceTimerEditor'
import RepeatingTimerEditor from './RepeatingTimerEditor'
import ScheduledTimerEditor from './ScheduledTimerEditor'

const registry = {
  [OnceTimerEditor.TYPE] : OnceTimerEditor,
  [RepeatingTimerEditor.TYPE] : RepeatingTimerEditor,
  [ScheduledTimerEditor.TYPE] : ScheduledTimerEditor
}

const defaults = {
  [OnceTimerEditor.TYPE] : OnceTimerEditor.DEFAULTS,
  [RepeatingTimerEditor.TYPE] : RepeatingTimerEditor.DEFAULTS,
  [ScheduledTimerEditor.TYPE] : ScheduledTimerEditor.DEFAULTS
}

const types = [
  { value : OnceTimerEditor.TYPE },
  { value : RepeatingTimerEditor.TYPE },
  { value : ScheduledTimerEditor.TYPE }
]

function createEditor( timer, props ) {
  if ( !timer || !timer.timer ) return null

  const TimerObj = registry[timer.timer.type]

  return TimerObj && <TimerObj timer={timer} {...props} />
}

exports.createEditor = createEditor
exports.defaults = defaults
exports.OnceTimerEditor = OnceTimerEditor
exports.RepeatingTimerEditor = RepeatingTimerEditor
exports.ScheduledTimerEditor = ScheduledTimerEditor
exports.types = types
